import React, { useRef, useState } from "react";
import * as c from "./desktopNavbarDropdown.module.scss";
import classNames from "classnames";

export default function DesktopNavbarDropdown({ label, children }) {
  const itemRef = useRef(null);
  const parentRef = useRef(null);
  const [isDropdownHidden, setDropdownHidden] = useState(true);

  const onMouseEnter = (height, left) => {
    const parent = document.getElementById("desktopNavbarItems");
    if (!parent) return;
    parent?.style.setProperty("--dropdownX", left + "px");
    parent?.style.setProperty("--dropdownHeight", height - 5 + "px");
    setDropdownHidden(false);
  };

  const onMouseLeave = () => {
    setDropdownHidden(true);
  };

  return (
    <>
      <li
        key={label}
        ref={parentRef}
        className={classNames(c.item, "dropdownItem")}
        onMouseEnter={() =>
          onMouseEnter(
            itemRef.current.offsetHeight,
            parentRef.current.getBoundingClientRect().left + parentRef.current.offsetWidth / 2
          )
        }
        onMouseLeave={onMouseLeave}
        aria-expanded={!isDropdownHidden}
      >
        <button className={c.link} type="button">
          {label} <span className={c.arrowIcon}></span>
        </button>
        <div className={c.dropdownContainer}>
          <div className={c.dropdownContent} ref={itemRef} key={label}>
            <div className={c.wrapper}>
              <div className={c.wrapperInner}>{children}</div>
            </div>
          </div>
        </div>
      </li>
    </>
  );
}
